"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isDeadlineClosing = exports.getMeldefristText = exports.getAreaTextForPreemptionUnit = void 0;
const getAreaTextForPreemptionUnit = unit => unit.subArea ? unit.subArea : unit.area ? unit.area : unit.city;
exports.getAreaTextForPreemptionUnit = getAreaTextForPreemptionUnit;
const isDeadlineClosing = date => {
  const date1 = new Date(date);
  const date2 = new Date();
  const diffHours = Math.ceil(Math.abs(date1.valueOf() - date2.valueOf()) / 3600000);
  return diffHours < 72;
};
exports.isDeadlineClosing = isDeadlineClosing;
const getMeldefristText = preemption => {
  const date1 = new Date(preemption.deadline);
  const date2 = new Date();
  const diffHours = Math.ceil(Math.abs(date1.valueOf() - date2.valueOf()) / 3600000);
  if (diffHours > 36) {
    return ' ' + Math.ceil(diffHours / 24) + ' dager';
  } else if (diffHours > 1) {
    return ' ' + diffHours + ' timer';
  } else {
    // Legge denne her for at den ikke regnes ut hver gang
    const diffMinutes = Math.ceil(Math.abs(date1.valueOf() - date2.valueOf()) / (1000 * 60));
    return ' ' + diffMinutes + ' minutter';
  }
};
exports.getMeldefristText = getMeldefristText;